export const ERROR_MESSAGES = {
  // Network errors
  NETWORK_ERROR: 'Unable to connect. Please check your internet connection.',
  TIMEOUT_ERROR: 'Request timed out. Please try again.',
  
  // Authentication errors
  AUTH_REQUIRED: 'You must be logged in to perform this action.',
  AUTH_EXPIRED: 'Your session has expired. Please log in again.',
  PERMISSION_DENIED: 'You don\'t have permission to perform this action.',
  
  // Database errors
  DUPLICATE_ENTRY: 'A record with this information already exists.',
  FOREIGN_KEY_VIOLATION: 'Cannot delete - this record is referenced by other data.',
  NOT_FOUND: 'The requested record could not be found.',
  
  // Validation errors
  REQUIRED_FIELD: 'Please fill in all required fields.',
  INVALID_EMAIL: 'Please enter a valid email address.',
  INVALID_PHONE: 'Please enter a valid phone number.',
  
  // Generic errors
  UNEXPECTED_ERROR: 'An unexpected error occurred. Please try again.',
  SAVE_FAILED: 'Failed to save changes. Please try again.',
  DELETE_FAILED: 'Failed to delete. Please try again.',
};

export function getUserFriendlyError(error: any): string {
  // Map Supabase error codes to user-friendly messages
  if (error?.code === '23505') return ERROR_MESSAGES.DUPLICATE_ENTRY;
  if (error?.code === '23503') return ERROR_MESSAGES.FOREIGN_KEY_VIOLATION;
  if (error?.code === 'PGRST301') return ERROR_MESSAGES.NOT_FOUND;
  if (error?.message?.includes('JWT')) return ERROR_MESSAGES.AUTH_EXPIRED;
  if (error?.message?.toLowerCase().includes('network')) return ERROR_MESSAGES.NETWORK_ERROR;
  
  return error?.message || ERROR_MESSAGES.UNEXPECTED_ERROR;
}
